import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from '../../../lib/react-redux-hooks';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { updateSavedSearches } from '../../../actions/feed';
import * as types from '../../../actions/actionTypes';

const useStyles = makeStyles(
  createStyles({
    undoToast: {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 2px 10px 3px rgba(0, 0, 0, 0.25)',
      border: '1px solid rgba(0, 0, 0, 0.5)',
      borderRadius: '5px',
      '@media (max-width: 1199px)': {
        maxWidth: '740px',
      },
      '@media (max-width: 768px)': {
        maxWidth: '100%',
      },
    },
    undoText: {
      cursor: 'pointer',
    },
  }),
);

/**
 * UndoToast component
 * @function UndoToast
 */
const UndoToast = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { search } = useSelector((state: any) => {
    return {
      search: state.feed.updateSaveSearch.search,
    };
  });

  const handleClickUndo = useCallback(() => {
    dispatch(
      updateSavedSearches(search.id, {
        saveSearch: true,
      }),
    );

    dispatch({
      type: types.CloseUndoSavedSearchToast,
    });
  }, [dispatch, search?.id]);

  useEffect(() => {
    let timeOutId: any;

    if (search) {
      timeOutId = setTimeout(() => {
        dispatch({
          type: types.CloseUndoSavedSearchToast,
        });
      }, 5000);
    }

    return () => {
      timeOutId && clearTimeout(timeOutId);
    };
  }, [search]);

  return (
    <Box
      position="fixed"
      width="100%"
      bottom="10%"
      padding="20px"
      display={!search && 'none'}
      zIndex={11}
      left={0}
      right={0}
      margin="auto"
    >
      <Box
        p={2}
        display="flex"
        width="80%"
        className={classes.undoToast}
        margin="auto"
        maxWidth="1184px"
      >
        <Box flex={1} fontSize="16px">
          You just deleted ‘{search?.searchName}’ saved search
        </Box>

        <Box
          color="#463264"
          fontWeight="bold"
          fontSize="16px"
          ml={1}
          display="flex"
          alignItems="center"
          className={classes.undoText}
          onClick={handleClickUndo}
        >
          UNDO
        </Box>
      </Box>
    </Box>
  );
};

export default UndoToast;
